import { render, staticRenderFns } from "./SamlLogin.vue?vue&type=template&id=5c553e64&"
import script from "./SamlLogin.vue?vue&type=script&lang=js&"
export * from "./SamlLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports